import React from 'react';
import Layout from '../components/Layout';
import './Home.css';

const Home = () => {

  return (
    <Layout>
      <section className="hero">
        <div className="hero-content">
          <div className="hero-app-icon">
            <img src="/app_icon.png" alt="Tonometer Scan App" className="app-icon-large" />
          </div>
          <h1>Stop Typing. Start Scanning.</h1>
          <p>Use your iPhone's camera to instantly read the numbers from your blood pressure monitor and save them securely to Apple Health. No manual entry required.</p>
          <div className="hero-buttons">
            <a 
              href="https://apps.apple.com/app/tonometer-scan" 
              target="_blank" 
              rel="noopener noreferrer"
              className="app-store-badge"
            >
              <img 
                src="/app-store-badge.svg" 
                alt="Download on the App Store" 
                style={{ height: '60px', width: 'auto' }}
              />
            </a>
            <a 
              href="https://www.apple.com/health/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="apple-health-badge"
            >
              <img 
                src="/apple-health-icon.svg" 
                alt="Apple Health" 
                style={{ height: '60px', width: 'auto' }}
              />
            </a>
          </div>
        </div>
        <div className="hero-image">
          <img src="/usage.png" alt="Person using Tonometer Scan app" />
        </div>
      </section>
    </Layout>
  );
};

export default Home;